import { defineStore } from 'pinia'
import { ref } from 'vue'
import { ReverseApi } from '@/core/apis/address.api'
import { ReportApi } from '@/core/apis/common/common.api'

export const useCommonData = defineStore(
  'commonData',
  () => {
    const V20241127_USER_IOS = 781 // ios新UI版本
    const V20241127_USER_ANDROID = 177 // android新UI版本
    const statusBarH = ref(0)
    const menuH = ref(50)
    const menuW = ref(60)
    const menuTop = ref(0)
    const minHeader = ref(50)
    const maxHeader = ref(98)
    const deviceAddress = ref<AnyObject>() // 设备定位地址
    const receiveAddress = ref<AnyObject>({
      lat: 14.5799397,
      lng: 121.0146403,
      address: '',
      city: '',
      positioning: '定位中...',
    }) // 用户选择地址
    const nearAddress = ref({
      lat: 14.5799397,
      lng: 121.0146403,
    })
    const searchChooseAdr = ref<AnyObject>()
    const isChooseAdr = ref(false)
    const screenWidth = ref(0)
    const screenHeight = ref(0)
    const windowWidth = ref(0)
    const windowHeight = ref(0)
    const comHost = ref('https://image.kuaizilife.com/')
    const isApp = ref(false)
    const isAndroid = ref(false)
    const isIOS = ref(false)
    const isMp = ref(false)
    const isAliPay = ref(false)
    const osVerison = ref()
    const publicParams = ref()
    const appParams = ref()
    const isWeixinBrowser = ref(false)
    const isQQ = ref(false)
    const isPc = ref(false)
    const pcLeft = ref(0)
    const pcRight = ref(0)
    const urlParams = ref<URLSearchParams>()
    const platformWeixinAppid = ref('wxbfec99cf4d47db50') // 平台小程序
    const singlestoreWeixinAppid = ref('wx120a5a2285bf769f') // 单店小程序
    const takeoutMiniProgramAppid = ref('wx986b8b11b47b72d5') // 外卖小程序
    const nowAppid = ref('')
    const isFlutter = ref(false)
    const kLifeUserApp = ref()
    const isWXBrowser = ref(false)
    const isAliBrowser = ref(false)

    // 获取设备信息
    const getSystemInfo = () => {
      return new Promise<void>((resolve) => {
        uni.getSystemInfo({
          success: (res: UniApp.GetSystemInfoResult) => {
            console.log(res)

            // 获取手机顶部状态栏高度
            statusBarH.value = res.statusBarHeight!
            // #ifdef MP-ALIPAY
            isAliPay.value = true
            // #endif
            // 获取胶囊高度+胶囊的上下间距
            // #ifdef MP
            const menuButtonInfo = uni.getMenuButtonBoundingClientRect()
            menuH.value = menuButtonInfo.height + (menuButtonInfo.top - statusBarH.value) * 2
            menuW.value = menuButtonInfo.width + 20
            menuTop.value = menuButtonInfo.top - statusBarH.value
            isMp.value = true
            // #endif
            // 头部最小高度
            minHeader.value = statusBarH.value + menuH.value + 10
            screenWidth.value = res.screenWidth
            screenHeight.value = res.screenHeight
            windowWidth.value = res.windowWidth
            windowHeight.value = res.windowHeight

            const ua = res.ua
            const osName = res.osName
            osVerison.value = res.romVersion
            isApp.value = ua?.toLowerCase().indexOf('kuailife_app') >= 0
            isFlutter.value = !!window?.KLifeUserApp
            kLifeUserApp.value = window?.KLifeUserApp
            isAndroid.value =
              osName === 'android' || ua?.indexOf('Android') > -1 || ua?.indexOf('Linux') > -1 // Android
            isIOS.value = osName === 'ios' || !!/(iPhone|iPad|iPod|iOS)/i.test(ua) // ios

            // #ifdef WEB
            isWXBrowser.value = !!/MicroMessenger/i.test(ua)
            isAliBrowser.value = !!/DingTalk/i.test(ua)
            // #endif

            // #ifndef MP
            const u = navigator.userAgent
            isWeixinBrowser.value = /micromessenger/i.test(navigator.userAgent) // 判断是不是微信浏览器
            isQQ.value = u.indexOf(' qq') > -1 && u.indexOf('mqqbrowser') < 0 // QQ内
            isMp.value =
              (!!navigator.userAgent.match(/micromessenger/i) &&
                !!navigator.userAgent.match(/miniprogram/i)) ||
              window.__wxjs_environment === 'miniprogram'
            const isPcDevice =
              !u.match(
                /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i,
              ) || res.deviceType === 'pc'
            const viewWidth = windowWidth.value || window.innerWidth
            isPc.value = isPcDevice && viewWidth >= 750
            const pcSideSpace = isPc.value ? Math.max((viewWidth - 750) / 2, 0) : 0
            pcLeft.value = pcSideSpace
            pcRight.value = pcSideSpace
            // #endif
            resolve()
          },
          fail: () => {
            resolve()
          },
        })
      })
    }

    // 获取位置信息
    const getLocation = async (isAgain = false): Promise<boolean> => {
      return new Promise((resolve) => {
        uni.getLocation({
          type: 'wgs84',
          isHighAccuracy: true,
          success: async (res: any) => {
            nearAddress.value = {
              lat: res.latitude,
              lng: res.longitude,
            }
            const resop = await getReverse(res.latitude, res.longitude)
            resolve(false)
            if (resop.code == 1 || resop.code == 200) {
              deviceAddress.value = resop.data
              console.log('设备定位：', deviceAddress.value)
              return
            }
          },
          fail: async (err: any) => {
            console.log('err', err)
            resolve(true)
            deviceAddress.value = undefined
            const resop = await getReverse(14.5799397, 121.0146403)
            if (resop.code == 1 || resop.code == 200) {
              receiveAddress.value = resop.data
            } else {
              receiveAddress.value = {
                lat: 14.5799397,
                lng: 121.0146403,
                name: '定位失败',
              }
            }
          },
        })
      })
    }

    const getReverse = async (lat: number, lng: number) => {
      const api = new ReverseApi()
      api.lat = lat
      api.lng = lng
      api.deviceLat = lat
      api.deviceLon = lng
      const resop = await api.postExec()
      if ((resop.code == 1 || resop.code == 200) && !isChooseAdr.value) {
        receiveAddress.value = resop.data
      }
      return resop
    }

    // 获取小程序信息
    const getAcountInfo = () => {
      const res = uni.getAccountInfoSync()
      nowAppid.value = res.miniProgram.appId
    }

    // 小程序上报
    const reportApiFun = async (name: string, data: any = '') => {
      const reportApi = new ReportApi()
      const obj: AnyObject = {
        name,
        time: Date.parse(new Date().toString()),
        data,
      }
      reportApi.param = obj
      try {
        await reportApi.bodyExec()
      } catch (err) {
        console.log(err)
      }
    }

    const isNewUi = (): boolean => {
      if (appParams.value) {
        return (
          (isIOS.value && appParams.value.build >= V20241127_USER_IOS) ||
          (isAndroid.value && appParams.value.build >= V20241127_USER_ANDROID)
        )
      }
      return false
    }

    return {
      statusBarH,
      menuH,
      menuW,
      menuTop,
      minHeader,
      maxHeader,
      deviceAddress,
      receiveAddress,
      searchChooseAdr,
      screenWidth,
      screenHeight,
      windowWidth,
      windowHeight,
      comHost,
      isApp,
      isFlutter,
      isAndroid,
      isIOS,
      isMp,
      isAliPay,
      isWeixinBrowser,
      isQQ,
      isPc,
      pcLeft,
      pcRight,
      publicParams,
      isChooseAdr,
      nearAddress,
      getSystemInfo,
      getLocation,
      getReverse,
      urlParams,
      osVerison,
      nowAppid,
      singlestoreWeixinAppid,
      platformWeixinAppid,
      takeoutMiniProgramAppid,
      getAcountInfo,
      appParams,
      reportApiFun,
      kLifeUserApp,
      isNewUi,
      V20241127_USER_IOS,
      V20241127_USER_ANDROID,
      isWXBrowser,
      isAliBrowser,
    }
  },
  {
    // 网页端配置
    // #ifdef H5
    persist: true,
    // #endif
    // 小程序端配置
    // #ifndef H5
    persist: {
      storage: {
        getItem(key) {
          return uni.getStorageSync(key)
        },
        setItem(key, value) {
          uni.setStorageSync(key, value)
        },
      },
    },
    // #endif
  },
)
